import React, { useEffect } from "react"
import { connect } from "react-redux"
import { showMyAccount } from "../actions/piano"
import { setIsStreaming, donePageLoading } from "../actions/offer"
import { initialize } from "../actions/whiteUi"
import { useTranslation, Trans } from "react-i18next";

function MyPage(props) {
  const { t } = useTranslation();

  useEffect(() => {
    props.donePageLoading(false)
    props.initialize()
    props.showMyAccount()
    props.setIsStreaming(false)
  }, [])
  window.setTimeout(function () {
    props.donePageLoading(true)
  }, 1000)
  return (
    <>
      <section className="account">
        <div id={"my-account"} style={{ margin: "15px" }} />
        <div id="myPage" />
        {props.loggedIn && (
            <section className="unsubscribe--box">
              <div>
                <p><Trans i18nKey="mypage.footerMsg" components={{ l: <a className="unsubscribe-link" href={t("mypage.footerMsgLink")}>link</a> }}/></p>
              </div>
            </section>
        )}
      </section>
    </>
  )
}
const mapStateToProps = state => {
  return {
    language: state.piano.language,
    donePageLoading: state.offer.donePageLoading,
    loggedIn: state.piano.loggedIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  initialize: () => dispatch(initialize()),
  showMyAccount: () => dispatch(showMyAccount()),
  setIsStreaming: (state) => dispatch(setIsStreaming(state)),
  donePageLoading: (state) => dispatch(donePageLoading(state))
})

export default connect(mapStateToProps, mapDispatchToProps)(MyPage)
